import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { httpOptions, httpOptionsExcel } from "./headers";

@Injectable({ providedIn: 'root' })

export class GCMService {

  private gcmtUrl = environment.gcmUrl;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Basic ' + btoa('estimator:!Estimator')
    })
  };

  constructor(private http: HttpClient) { }

  public getGCMRegions() {
    return this.http.get<any>(this.gcmtUrl + '/regions',httpOptions);
  }

  public getRegionGCMs(region: string) {
    return this.http.get<any>(this.gcmtUrl + '/' + region,httpOptions);
  }

  public addGCM(gcm: any) {
    return this.http.post<any>(this.gcmtUrl, gcm,httpOptions).subscribe();
  }

  public updateGCM(id: string, gcm: any): Subscription  {
    return this.http.put<any>(this.gcmtUrl +'/'+id, gcm,httpOptions).subscribe();
  }

  public getAllCECOS() {
    return this.http.get(this.gcmtUrl + "/getAllCECO",httpOptions);
  }

  public updateCECO(id: string, ceco: any)  {
    return this.http.put<any>(this.gcmtUrl +'/updateCECO/'+id, ceco,httpOptions)
  }

  public getAllGcmsByCostCenter(costCenter: string) {
    return this.http.get(this.gcmtUrl + "/getGCMCECO/" + costCenter,httpOptions);
  }

  public upload(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(this.gcmtUrl+"/upload", formData,httpOptionsExcel);
  }

}
